import { Chip } from "@mui/material";
import React from "react";

const ChipComponent = ({ label, ...props }) => {
  return <Chip label={label} {...props} />;
};

export default ChipComponent;
